import BaseComponent from 'scripts/BaseComponent.js';
import FormValidate from 'scripts/helpers/formValidate.js';

export default class AccountLoginForm extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      loginForm: '.js-login-form',
      loginSubmit: '.js-login-submit',
      recoverForm: '.js-recover-form',
      recoverSubmit: '.js-recover-submit',
      resetPasswordMsg: '.js-reset-password-msg',
    };

    this.dom = {
      $component: component,
      $loginForm: this.$get(this.refs.loginForm),
      $loginSubmit: this.$get(this.refs.loginSubmit),
      $recoverForm: this.$get(this.refs.recoverForm),
      $recoverSubmit: this.$get(this.refs.recoverSubmit),
      $resetPasswordMsg: this.$get(this.refs.resetPasswordMsg),
    };

    this.state = {
      url: new URL(document.location),
      activeClass: 'is-active',
      loginFormValidate: new FormValidate(this.dom.$loginForm),
      recoverFormValidate: new FormValidate(this.dom.$recoverForm),
    };

    this.mount();

    this.init();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    dom.$loginSubmit.addEventListener('click', (e) => this.validate(e, state.loginFormValidate));
    dom.$recoverSubmit.addEventListener('click', (e) => this.validate(e, state.recoverFormValidate));
  }

  init() {
    const { dom, state } = this;
    const resetPasswordParam = state.url.searchParams.get('reset_password');
    if (resetPasswordParam) {
      dom.$resetPasswordMsg.classList.add(state.activeClass);
    }
  }

  validate(e, validator) {
    const hasErrors = validator.validate();

    if (hasErrors) {
      e.preventDefault();
    }
  }
}
